module.exports = __webpack_public_path__ + "img/max-file-subtract--xml.25c4fb92.svg";